import React, { useCallback, useMemo } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { I18n } from 'aws-amplify';
import Tooltip from '../common/Tooltip';
import linkIcon from '../img/link_icon_gray.svg';
import styles from './styles.module.css';

// 64 文字 + 空白 の計 65 文字
const maxNameLength = 65;
const nameEndings = '...';

const UserMenu = ({
  location,
  administeringAccountCount,
  open,
  onClose,
  openSwitchAccountMenu,
  userData,
  signOut,
}) => {
  const isMypage = useMemo(() => !location.pathname.includes('management'), [location.pathname]);
  const className = useMemo(() => `${styles.menu} ${open ? styles.visible : styles.hidden}`, [
    open,
  ]);
  const hasMultipleAdministeringAccounts = useMemo(() => administeringAccountCount > 1, [
    administeringAccountCount,
  ]);
  const userName = useMemo(() => {
    if (!(userData && 'family_name' in userData && 'given_name' in userData)) return '';
    return `${userData.family_name} ${userData.given_name}`;
  }, [userData]);

  const titleOfHonor = window.LAPLACEID_LOCALE === 'ja' ? '様' : ''; // Only show for Japanese

  const createListItemForMypage = useCallback(() => {
    if (!administeringAccountCount) return;
    return (
      <li
        onClick={() => {
          onClose();
          if (hasMultipleAdministeringAccounts) openSwitchAccountMenu();
        }}
      >
        {hasMultipleAdministeringAccounts ? (
          I18n.get('Management')
        ) : (
          <Link to='/management/account' target='_blank'>
            {I18n.get('Management')}
          </Link>
        )}
        <img src={linkIcon} className={styles.linkIcon} alt='' />
      </li>
    );
  }, [
    administeringAccountCount,
    hasMultipleAdministeringAccounts,
    onClose,
    openSwitchAccountMenu,
  ]);

  const createListItemForManagement = useCallback(() => {
    return (
      <>
        {hasMultipleAdministeringAccounts && (
          <li onClick={openSwitchAccountMenu}>{I18n.get('Account Switching')}</li>
        )}
        <li onClick={onClose}>
          <Link to='/' target='_blank'>
            {I18n.get('My page')}
          </Link>
          <img src={linkIcon} className={styles.linkIcon} alt='' />
        </li>
      </>
    );
  }, [hasMultipleAdministeringAccounts, openSwitchAccountMenu, onClose]);

  return (
    <div className={className}>
      <ul>
        <li>
          {userName.length <= maxNameLength ? (
            `${userName}${titleOfHonor}`
          ) : (
            <Tooltip title={`${userName}${titleOfHonor}`}>{`${userName.substring(
              0,
              maxNameLength
            )}${nameEndings}${titleOfHonor}`}</Tooltip>
          )}
        </li>
        {isMypage ? createListItemForMypage() : createListItemForManagement()}
        <li onClick={signOut}>{I18n.get('LOGOUT')}</li>
      </ul>
    </div>
  );
};

export default withRouter(UserMenu);
